import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';

	interface main {
		id ?: string | number,
		size ?: string,
		ValueKey ?: string,
		LabelKey ?: string,
		width ?: string | number,
		disabled ?: boolean,
		IsAuto ?: boolean,
		WarehouseId ?: string | number,
	}
export default /*#__PURE__*/_defineComponent({
  __name: 'AreaSelect',
  props: {
    id: { default: "" },
    size: { default: "default" },
    ValueKey: { default: "value" },
    LabelKey: { default: "label" },
    width: { default: "100%" },
    disabled: { type: Boolean, default: false },
    IsAuto: { type: Boolean, default: false },
    WarehouseId: { default: "" }
  },
  emits: ["update:id", "change", "clear"],
  setup(__props: any, { emit: __emit }) {

	;

	const props = __props;

	const { proxy } = getCurrentInstance() as any;
	const emits = __emit;
	const AreaId = ref<any>("");
	const AreaList = ref<any>([]);
	const loading = ref(false);
	const placeholder = ref("请选择库区");

	watch(() => props.id, (n : any) => {
		AreaId.value = n;
	});

	onMounted(() => {
		AreaId.value = props.id;
		if (props.IsAuto) {
			if (proxy.$store.state.IsRefreshAreaList) {
				GetData();
			} else {
				if (proxy.$store.state.AreaInfo) {
					if (proxy.$store.state.AreaInfo.id == props.WarehouseId) {
						AreaList.value = proxy.$store.state.AreaInfo.list;
					} else {
						GetData();
					}
				} else {
					GetData();
				}
			}
		}
	});

	const AreaChange = (data : any) => {
		emits("update:id", data);
		emits("change", data);
	};
	const AreaClear = () => {
		emits("clear");
	};
	const SelectFocus = () => {
		if (proxy.$store.state.IsRefreshAreaList) {
			GetData();
		} else {
			if (proxy.$store.state.AreaInfo) {
				if (proxy.$store.state.AreaInfo.id == props.WarehouseId) {
					AreaList.value = proxy.$store.state.AreaInfo.list;
				} else {
					GetData();
				}
			} else {
				GetData();
			}
		}
	};
	const GetData = () => {
		loading.value = true;
		proxy.$api.tokenRequest({
			url: '/admin/warehouse/area',
			data: {
				warehouse_id: props.WarehouseId,
				sn: "",
				name: "",
				is_page: 0,
			},
			success: (res : any) => {
				loading.value = false;
				AreaList.value = res.data;
				proxy.$store.commit("GetAllList", {
					type: 6,
					id: props.WarehouseId,
					list: res.data,
				});
			},
			fail: () => {
				loading.value = false;
			},
		});
	};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "remote-show-suffix": "",
    filterable: "",
    clearable: "",
    style: _normalizeStyle({'width': `${_ctx.width}`}),
    disabled: _ctx.disabled,
    size: _ctx.size,
    modelValue: AreaId.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((AreaId).value = $event)),
    loading: loading.value,
    onFocus: SelectFocus,
    placeholder: placeholder.value,
    onChange: AreaChange,
    onClear: AreaClear
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(AreaList.value, (v) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: v[_ctx.ValueKey],
          label: v[_ctx.LabelKey],
          value: v[_ctx.ValueKey]
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["style", "disabled", "size", "modelValue", "loading", "placeholder"]))
}
}

})